import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MissionVisionSection from './components/MissionVisionSection';
import ProductsSection from './components/ProductsSection';
import SuppliersSection from './components/SuppliersSection';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <main className="font-outfit">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <MissionVisionSection />
      <ProductsSection />
      <SuppliersSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
